import React from 'react';
import { Redirect } from 'react-router';

import { connect } from 'react-redux';
import { createSelector } from 'reselect';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import property from 'lodash/property';

import Composition from '@nerdwallet/react-composition';
import StructuredContent from '@nerdwallet/structured-content';

import * as fullComponentLibrary from '../../lib/component-lib-full';
import { buildTree, transformNode } from '../../lib/outline-manipulation';
import { getIntegrationsLib } from '../../lib/integrations/integrations-helpers';
import { NotFound } from '../../routes/generic';
import { isValid } from '../../lib/route-utils';

const ConfigPage = ({ componentDocument }) => {
  const integrationsLibrary = getIntegrationsLib(
    get(componentDocument, 'meta.integrationsFileName')
  );
  const valid = isValid(componentDocument);
  const fallBack = get(componentDocument, 'meta.fallBack');

  if (!valid) {
    return fallBack ? (
      <Redirect to={fallBack} />
    ) : (
      <NotFound
        reason="No valid component document for this page."
        source="ConfigPage"
      />
    );
  }

  // Fall back to using Composition if:
  // - integrationsLibrary is present (legacy functionality with no structured-content equivalent;
  //   /l/total-rewards still uses this unfortunately)
  if (integrationsLibrary) {
    return (
      <Composition
        componentDocument={componentDocument}
        componentLibrary={fullComponentLibrary}
        integrationsLibrary={integrationsLibrary}
      />
    );
  }

  return (
    <StructuredContent>{transformNode(componentDocument)}</StructuredContent>
  );
};

ConfigPage.propTypes = Composition.propTypes;

ConfigPage.displayName = 'ConfigPage';

export default connect(
  createSelector(property('builder.flatOutline'), (flatOutline) => ({
    componentDocument: buildTree(flatOutline),
  }))
)(ConfigPage);
